module.exports = __webpack_public_path__ + "static/media/img_7.1fb2ab33.png";